<template>
  <ChatInterface />
</template>

<script setup>
import ChatInterface from './components/ChatInterface.vue';
</script>

<style>
/* Import Google Font */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap');

body {
  margin: 0;
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #e9e9e9; /* Latar belakang abu-abu di luar container chat */
}
</style>
